@use 'sass:map';
@import '../../themes/capsule.globals';

:host {
  display: flex;

  position: fixed;
  z-index: map.get($z-indices, 'drawer');
}

:host(.left) {
  left: 0;
  top: 0;
  transition: left;
}

:host(.right) {
  right: 0;
  top: 0;
  transition: right;
}

:host(.top) {
  top: 0;
  left: 0;
  transition: top;
}

:host(.bottom) {
  bottom: 0;
  left: 0;
  transition: bottom;
}

.container {
  flex: 1;
  overflow: auto;
  z-index: map.get($z-indices, 'drawer');
}
